import React, {Component} from "react"
import {findIndex} from "lodash"

import authentication from "@irati/auth"
import {canModifyUserMembership} from "@irati/identity/utils/team/membership"
import {User as UserType, Team} from "@irati/types"

import User, {UserRemoveButton} from "../../Users/User"
import UserFilter from "../../Users/UserFilter"

interface Props {
  removeUserFromTeam: (user: UserType) => void,
  team: Team,
  users: UserType[],
  selectedEmployees: UserType[],
  onToggle: (user: UserType) => void,
  onToggleAll: () => void,
  hideCheckbox: boolean,
  businessUnits: Team[]
}

class TeamUserListRender extends Component<Props> {
  static defaultProps = {
    users: [],
    selectedEmployees: [],
    hideCheckbox: false
  }

  action = (user: UserType) => {
    const {removeUserFromTeam} = this.props
    // Do not allow edit if current user is manager and target is admin
    if (canModifyUserMembership(this.props.team, authentication.user(), user)) {
      return <UserRemoveButton user={user} onRemove={() => removeUserFromTeam(user)} />
    }

    return null
  }

  getBusinessUnit = (user: User) => {
    const {businessUnits} = this.props
    const businessUnit = businessUnits
      .find((team) =>
        user.teamIds.find((userTeamUuid) => userTeamUuid === team.uuid)
      )
    return businessUnit?.public_name
  }

  render() {
    const {users, team, selectedEmployees, onToggle, onToggleAll, hideCheckbox, businessUnits} = this.props

    return (
      <div>
        <UserFilter
          key="headerUser"
          onToggleAll={onToggleAll}
          checked={selectedEmployees.length === users.length}
          hideTeam
          hideCheckbox={hideCheckbox}
          hideBusinessUnit={!(businessUnits && businessUnits.length > 0)} />
        {this.props.users.map((user) => (
          <User
            key={user.uuid}
            user={user}
            team={team}
            showTeams={false}
            onToggle={onToggle}
            businessUnit={this.getBusinessUnit(user)}
            checked={findIndex(selectedEmployees, (test) => test.uuid === user.uuid) > -1}
            showCheckbox={!hideCheckbox}
            action={this.action(user)} />
        ))}
      </div>
    )
  }
}

export default TeamUserListRender
